import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  NoticesData,
  NoticesListData,
} from '../../api/service/NoticeInterfaces';
import NoticeService from '../../api/service/member/NoticeService';
import leaf from '../../assets/images/leaf.svg';
import Pagination from '../../components/Pagination';
import { formatDate } from '../../utils/formatDate';
import Button from '../../components/Button';

const NoticeTabWrapper = styled.div``;

const NoticeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
  img {
    width: 20px;
  }
`;

const TableContainer = styled.div`
  min-height: 481px;
  overflow-x: auto;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${(props) => props.theme.colors.whiteColor};
`;

const TableBox = styled.div`
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${(props) => props.theme.colors.whiteColor};

  @media (max-width: 768px) {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: white;

  tr {
    border-bottom: 1px solid #ddd;
  }

  tr:nth-child(12) {
    border-bottom: none; /* 마지막 행의 border 제거 */
  }

  th,
  td {
    font-size: 16px;
    padding: 10px;
    text-align: center;
    vertical-align: middle; /* 세로 정렬 */
    white-space: nowrap; /* 줄바꿈 방지 */
  }

  th {
    background-color: #85c1a9;
    color: white;
    font-weight: 500;
  }

  th:first-child {
    border-top-left-radius: 10px;
  }

  th:last-child {
    border-top-right-radius: 10px;
  }

  /* 제목 열을 가장 넓게 설정 */
  th:nth-child(2),
  td:nth-child(2) {
    width: 50%; /* 제목 열의 폭을 설정 */
  }

  @media (max-width: 768px) {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;

    tr {
      border-bottom: 1px solid #ddd;
    }

    th,
    td {
      font-size: 12px;
      padding: 10px;
      text-align: center;
      vertical-align: middle; /* 세로 정렬 */
      white-space: nowrap; /* 줄바꿈 방지 */
    }

    th {
      font-weight: 400;
    }

    th:first-child {
      border-top-left-radius: 0px;
    }

    th:last-child {
      border-top-right-radius: 0px;
    }

    /* 제목 열 폭 조정 */
    th:nth-child(2),
    td:nth-child(2) {
      width: 40%; /* 모바일 환경에서의 폭 */
    }
  }
`;

const TableContent = styled.div`
  white-space: pre-wrap; /* 줄바꿈과 공백 유지 */
  word-wrap: break-word; /* 단어 단위로 줄바꿈 */
  word-break: break-word; /* 긴 단어도 강제 줄바꿈 */
  padding: 10px;
  background-color: #ebf0ee;
  height: 426px;
`;
const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
`;

function NoticeTab1() {
  const [notices, setNotices] = useState<NoticesListData[]>([]); // 공지사항 데이터를 저장하는 상태
  const [selectedIndex, setSelectedIndex] = useState<number>(0); // 공지사항 데이터를 저장하는 상태
  const [selectedNotice, setSelectedNotice] = useState<NoticesData | null>(
    null
  ); // 선택된 공지사항

  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(1); // 총 페이지 수

  const handleRowClick = async (index: number, noticeId: string) => {
    try {
      const response = await NoticeService.getNoticeDetail(noticeId);
      setSelectedNotice(response.data); // 선택된 공지사항 데이터 저장
      setSelectedIndex(index);
    } catch (error) {
      console.error('공지사항 상세 조회 실패:', error);
    }
  };
  const handleButtonClick = async () => {
    setSelectedNotice(null); // 선택된 공지사항 데이터 저장
  };

  const handlePageChange = (page: number) => {
    //console.log('페이지 변경:', page + 1);
    setCurrentPage(page);
    fetchNotices(page); // 페이지 변경 시 데이터 로드
  };

  useEffect(() => {
    fetchNotices(0);
  }, []);

  const fetchNotices = async (currentPage: number) => {
    try {
      const response = await NoticeService.getNoticesList(currentPage, 12); // 페이지, 크기 지정
      setNotices(response.data.content); // items로 데이터 접근
      setTotalPages(response.data.totalPages);
    } catch (err) {
      console.log(err);
      alert(err);
    }
  };

  return (
    <NoticeTabWrapper>
      <NoticeHeader>
        <img src={leaf} alt="leaf" />
        <h1>공지사항</h1>
      </NoticeHeader>
      {selectedNotice ? (
        <>
          <TableContainer id="table-container">
            <TableBox>
              <Table>
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>제목</th>
                    <th>작성자</th>
                    <th>작성날짜</th>
                  </tr>
                </thead>
                <tbody>
                  <tr key={selectedNotice.noticeId}>
                    <td>{selectedIndex + 1}</td>

                    <td>
                      {selectedNotice.title.length > 30
                        ? selectedNotice.title.substring(0, 30) + '...'
                        : selectedNotice.title}
                    </td>
                    <td>관리자</td>
                    <td>{formatDate(selectedNotice.regDate)}</td>
                  </tr>
                </tbody>
              </Table>
            </TableBox>
            <TableContent>{selectedNotice.content}</TableContent>
          </TableContainer>
          <ButtonContainer>
            <Button save={true} onClick={() => handleButtonClick()}>
              목록
            </Button>
          </ButtonContainer>
        </>
      ) : (
        <>
          <TableContainer id="table-container">
            <TableBox>
              <Table>
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>제목</th>
                    <th>작성자</th>
                    <th>작성날짜</th>
                  </tr>
                </thead>
                <tbody>
                  {notices.length === 0 && (
                    <tr>
                      <td
                        colSpan={13}
                        style={{ textAlign: 'center', padding: '20px' }}
                      >
                        데이터가 없습니다.
                      </td>
                    </tr>
                  )}
                  {notices.map((item, index) => (
                    <tr
                      key={item.noticeId}
                      onClick={() => handleRowClick(index, item.noticeId)}
                    >
                      <td>{index + 1}</td>

                      <td>
                        {item.title.length > 30
                          ? item.title.substring(0, 30) + '...'
                          : item.title}
                      </td>
                      <td>관리자</td>
                      <td>{formatDate(item.regDate)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableBox>
          </TableContainer>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </NoticeTabWrapper>
  );
}

export default NoticeTab1;
